// extracted by mini-css-extract-plugin
module.exports = {"Button":"DownloadAssets_Button__2rsWD","Icon":"DownloadAssets_Icon__1_WL8","ButtonEdit":"DownloadAssets_ButtonEdit__1OfDe"};